import { isUndefined } from "lodash";
import type { FieldErrors, FieldValues } from "react-hook-form";

export const isGTZero = (number: number | undefined) =>
  !isUndefined(number) && number > 0;

export const getIsContractSymbol = (symbol: string) => symbol.length > 12;

export const concatFormErrorMessages = <T extends FieldValues>(
  fieldErrors: FieldErrors<T>,
) =>
  Object.entries(fieldErrors)
    .filter(([, error]) => !!error?.message)
    .map(([key, error]) => `${key} ${error?.message ?? ""}`)
    .join(", ");
